import { render, staticRenderFns } from "./TicketPrincipalEnvio.vue?vue&type=template&id=7820dc76&scoped=true&"
import script from "./TicketPrincipalEnvio.vue?vue&type=script&lang=js&"
export * from "./TicketPrincipalEnvio.vue?vue&type=script&lang=js&"
import style0 from "./TicketPrincipalEnvio.vue?vue&type=style&index=0&id=7820dc76&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820dc76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
